import { call, put, select, takeLatest } from 'redux-saga/effects';
import { stockActions as actions } from '.';
import { selectErpSystem } from 'app/features/erpSystem/slice/selectors';
import { erpalPayloadDTO } from '../../price/slice/utils';
import { StockStatusResponse } from './types';

export function* fetchStockStatus(action) {
  const { getStockStatusSuccess, getStockStatusFail } = actions;

  try {
    const erpSystem = yield select(selectErpSystem);

    const itemsTransformed = yield erpalPayloadDTO(action.payload);

    const itemsStockResponse = yield call(
      fetch,
      `/valve-configurator/api/stockStatus?erpSystem=${erpSystem}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(itemsTransformed),
      },
    );

    if (itemsStockResponse.status !== 200) {
      return yield put(getStockStatusFail('failed to fetch'));
    } else {
      const itemsStockStatus: StockStatusResponse =
        yield itemsStockResponse.json();

      if (!itemsStockStatus) {
        return yield put(getStockStatusFail('No stocks fetched'));
      }

      return yield put(getStockStatusSuccess(itemsStockStatus));
    }
  } catch (e) {
    yield put(getStockStatusFail(e));
  }
}
export function* stockSaga() {
  yield takeLatest(actions.getStockStatus.type, fetchStockStatus);
}
